"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _CryptoWalletDepositWorkflowComponent = _interopRequireDefault(require("./CryptoWalletDepositWorkflowComponent"));
var _depositWithdrawalSelectors = require("../../../../redux/selectors/depositWithdrawalSelectors");
var _snackbarActions = require("../../../../redux/actions/snackbarActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    addressList: state.deposit.depositInfo,
    product: (0, _depositWithdrawalSelectors.depositProductSelector)(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showSnack: function showSnack(text) {
      return dispatch((0, _snackbarActions.showSnack)({
        id: 'depositCopyAddress',
        text: text,
        type: 'success'
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CryptoWalletDepositWorkflowComponent["default"]);